export const getProfileFullName = ({ firstName = '' } = {}) =>
  `${firstName}`.trim();

export const getProfileFullNameOrUsername = ({
  firstName = '',
  username = '',
} = {}) => {
  return getProfileFullName({ firstName }) || (username ? `@${username}` : '');
};
